import { Box, Dialog, IconButton } from "@mui/material";
import { useEffect } from "react";

import BrandBody from "features/Influencer/Discover/DetailedBrandView/components/BrandBody";
import { useBrandDetails } from "features/Influencer/Discover/DetailedBrandView/components/BrandBody/useBrandDetails";
import { BrandCardSource } from "features/Influencer/Discover/Results/schema";

interface MoreInfoDialogProps {
  brandDetailsId: number;
  open: boolean;
  onClose: () => void;
}

export default function MoreInfoDialog({
  brandDetailsId,
  open,
  onClose,
}: MoreInfoDialogProps) {
  const {
    fetchSelectedBentobrand,
    selectedBrand,
    fetchLoading,
    similarBrands,
    fetchSimilarLoading,
  } = useBrandDetails({ brandDetailsId });

  useEffect(() => {
    if (brandDetailsId) {
      fetchSelectedBentobrand();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandDetailsId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <IconButton
        sx={{
          color: "primary.main",
          fontSize: 14,
          position: "absolute",
          right: 10,
          top: 10,
        }}
        onClick={onClose}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <BrandBody
        selectedBrand={selectedBrand}
        fetchLoading={fetchLoading}
        similarBrands={similarBrands}
        source={BrandCardSource.MORE_INFO_BRAND}
        fetchSimilarLoading={fetchSimilarLoading}
        isPopupView
      />
    </Dialog>
  );
}
